/**
 * Lazy-loaded icons with encapsulated Suspense boundaries.
 */
import React, { Suspense } from 'react';

// oxlint-disable-next-line @atlassian/no-restricted-imports
import { lazyForPaint } from '@atlassian/react-loosely-lazy';

const LazyPagerDutyIconComponent = lazyForPaint(
	() => import(/* webpackChunkName: "icon-pagerduty" */ './utils').then((m) => m.PagerDutyIcon),
	{ moduleId: '@atlassian/rovo-connectors-config/pagerduty/icon' },
);

const LazyPagerDutySearchResultIconComponent = lazyForPaint(
	() =>
		import(/* webpackChunkName: "icon-pagerduty-search-result" */ './utils').then(
			(m) => m.PagerDutySearchResultIcon,
		),
	{ moduleId: '@atlassian/rovo-connectors-config/pagerduty/search-result-icon' },
);

/**
 * Exported icons with self-contained Suspense boundaries.
 * Consumers can use these directly without wrapping in LazySuspense.
 */
export const PagerDutyIcon = (): React.JSX.Element => (
	<Suspense fallback={null}>
		<LazyPagerDutyIconComponent />
	</Suspense>
);

export const PagerDutySearchResultIcon = (): React.JSX.Element => (
	<Suspense fallback={null}>
		<LazyPagerDutySearchResultIconComponent />
	</Suspense>
);
